import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ConfigService from "../services/configService";
import AnalyticsService from "../services/analytics";

/**
 * Initializes Sentry for the React frontend.
 * Fetches configuration from the backend (which reads from SSM).
 * Fallback to environment variables for local development.
 */
export const initSentry = async () => {
  const remoteConfig = await ConfigService.getSentryConfig();
  const gaId = remoteConfig?.ga_measurement_id;

  const dsn = remoteConfig?.sentry_dsn || process.env.REACT_APP_SENTRY_DSN;
  const environment = remoteConfig?.environment || process.env.NODE_ENV || "development";
  const tracesSampleRate = remoteConfig?.traces_sample_rate ||
    parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1");

  if (!dsn) {
    console.warn("Sentry DSN not found, error tracking disabled.");
  } else {
    Sentry.init({
      dsn: dsn,
      integrations: [new BrowserTracing()],
      tracesSampleRate: tracesSampleRate,
      environment: environment,
    });
  }

  // 2. Initialize Google Analytics
  AnalyticsService.initialize(gaId);
};
